'use strict';

/* global angular */

/* Initialize stores */

const _initStore = (store) => {
  store.init();
};

angular.module('dash.siteStore', ['common.utils'])
.service('SiteStore', require('./SiteStore'))
.factory('SiteActions', require('../site/SiteActions'))
.run(['SiteStore', _initStore]);

angular.module('dash.annotationStore', [])
.service('AnnotationStore', require('./AnnotationStore'))
.run(['AnnotationStore', _initStore]);

angular.module('dash.overlayStore', [])
.service('OverlayStore', require('./OverlayStore'))
.run(['OverlayStore', _initStore]);

angular.module('dash.measurementStore', [])
.service('MeasurementStore', require('./MeasurementStore'))
.run(['MeasurementStore', _initStore]);

angular.module('dash.dataCaptureStore', ['dash.measurementStore'])
.service('DataCaptureStore', require('./DataCaptureStore'))
.run(['DataCaptureStore', _initStore]);

angular.module('dash.planStore', [])
.service('PlanStore', require('./PlanStore'))
.run(['PlanStore', _initStore]);

angular.module('dash.syncStore', [])
.service('SyncStore', require('./SyncStore'))
.run(['SyncStore', _initStore]);

angular.module('dash.userStore', [])
.service('UserStore', require('./UserStore'))
.run(['UserStore', _initStore]);



// WEBPACK FOOTER //
// ./src/app/dash/dataStores/index.js